export {
  getParentWindow,
  DatabaseContentContextProvider,
  type DatabaseContent
} from './context/DatabaseContentContext.tsx';
export { isAIFCStagingAreaView } from './utils.ts';
export * from './gateway.ts';
export { initializeContentSyncMachine } from './hooks/initializeContentSyncMachine.ts';
export { useDatabaseContent } from './hooks/useDatabaseContent.ts';
export {
  viewState,
  setView,
  getCachedViewSnapshot,
  getCachedViewSnapshotForSelections,
  subscribeViewProjectionChanges,
  subscribeViewIdentityChanges,
  type ViewIdentityChanges
} from './state/view.ts';
